const shouldSkipCalculatingCombinator = (selection, orderLine) =>  {
	if (!selection) {
		return true;
	}

	if(orderLine.type === "CombinatorLine") {
		return true;
	}

	const groups = selection.groups || [];
	const configurations = selection.configurations || [];
	return groups.length > 0 || configurations.length > 0;
};

export default {
	methods: {
		getSelection(orderLine) {
			const selection = this.cartProducts.find(sel => sel.productId === orderLine.productId && sel.productSelectionId === orderLine.productSelectionId);
			if (shouldSkipCalculatingCombinator(selection, orderLine)) {
				return selection;
			}

			const quantityReduced = this.filteredOrderLines
				.filter((sel) => sel.type === "CombinatorLine")
				.reduce((prev, curr) => prev.concat(...curr.productIds), [])
				.filter((productId) => productId === selection.productId)
				.length;

			return {
				...selection,
				quantityWithoutCombinator: selection.quantity - quantityReduced
			};
		},
		getProducts(orderLine) {
			if (orderLine.type === "CombinatorLine") {
				return orderLine.productIds.map(id => this.productCatalog.getProduct(id));
			}
			return [this.productCatalog.getProduct(orderLine.productId)];
		}
	},
	computed: {
		filteredOrderLines() {
			return this.orderLines.filter(ol => !["Discount", "Meta", "Delivery", "FreeMeal"].includes(ol.type));
		},
		globalDiscounts() {
			return ["FreeMeal", "Discount"]
				.map((type) => {
					const orderLine = (this.orderLines || []).find((e) => e.type === type);
					const receiptLine = (this.receiptLines || []).find((e) => e.type === type);
					if (!orderLine || !receiptLine) {
						return null;
					}
					return {
						receiptLine,
						orderLine,
						type
					};
				})
				.filter(Boolean);
		}
	}
};
